import React from 'react';
import styled, { css } from 'styled-components';

import ButtonTs from '@lt/components/components/ButtonTs';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Throbber from '@lt/components/components/Throbber';

import { useCigarette } from '../../context';
import { isTouristsStep } from '../../utils';

interface SearchButtonProps {
  loading?: boolean;
  shouldDisplay?: boolean;
}

export const SearchButton = ({ loading, shouldDisplay }: SearchButtonProps) => {
  const {
    state: { isWizard, isMobile, steps },
  } = useCigarette();

  if (isWizard && !isTouristsStep(steps) && !shouldDisplay) {
    return null;
  }

  return (
    <ButtonContainer $isMobile={isMobile} $isWizard={isWizard}>
      <SubmitButton type="submit" variant="primary" $isMobile={isMobile}>
        {loading ? <Throbber size={isMobile ? 30 : 20} color="#f5a623" /> : 'Найти'}
      </SubmitButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div<{
  $isMobile: boolean;
  $isWizard?: boolean;
}>`
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 0 8px;
  border-radius: 0 4px 4px 0;
  margin-left: auto;
  position: relative;

  ${({ $isMobile, $isWizard }) =>
    $isMobile &&
    css`
      ${$isWizard &&
      `
        position: fixed;
        bottom: 0;
        z-index: 1;
      `}
      width: 100%;
      margin-top: auto;
      order: 1;
      padding: ${$isWizard ? '8px' : '0'};
      border-radius: 2px;
    `}
`;

const SubmitButton = styled(ButtonTs)<{ $isMobile?: boolean }>`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    height: ${({ $isMobile }) => ($isMobile ? '48px' : '38px')};
    width: 100%;
    min-width: 80px;
    ${({ $isMobile }) =>
      $isMobile &&
      css`
        font-size: 16px;
        line-height: 20px;
      `};
  }
`;
